import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SharedService } from 'src/app/services/shared-service.service';
import { SweetAlertService } from 'src/app/services/sweetalert.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

  contactUs!: FormGroup;
  contactEmail:string="info@digiworldexpo.com";
  router: any;
  selectedIndex: number | null = null;

  constructor(
    private fb: FormBuilder,
    private shareService: SharedService,
    private sweetAlertService: SweetAlertService
  ){}

  ngOnInit(): void {
  this.topOfPage();
    this.contactUs = this.fb.group({
      name: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      phoneNumber: new FormControl('', [Validators.required]),
      message: new FormControl('')
    })
      
  }
  topOfPage(): void {
    const topOfPage = document.querySelector('app-website-header');
    if (topOfPage) {
      topOfPage.scrollIntoView({ behavior: 'smooth' });
    }else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
  faq: any = [
    
    {
      question: 'How can I join Medworld Expo as an OEM or Distributor?',
      answer: 'Simply sign up on our website through the OEM or Distributor registration page.',
      display: false
    },
    {
      question: 'Can I update or change my account details after signing up?',
      answer: 'Yes, you can update your account information anytime by logging into your account and navigating to the profile settings. If you face any issues, please contact our support team for assistance.',
      display: false
    },
    {
      question: 'Where can I find information on upcoming webinars?',
      answer: 'You can find all information on upcoming webinars on "Webinars" under the "Knowledge Center" section on our website. For any additional inquiries, feel free to reach out through the contact form.',
      display: false
    },
    // {
    //   question: 'Is it safe to use this website?',
    //   answer: 'Yes, our website is safe and secure. We use industry-standard security measures to protect your data and ensure that your booking is processed securely.',
    //   display: false
    // },
    // {
    //   question: 'How to contact customer support?',
    //   answer: 'You can contact our customer support team via email or phone. We are available 24/7 to assist you with any questions or concerns you may have.',
    //   display: false
    // }
  ];
  showAnswer(idx: number) {
  this.selectedIndex = this.selectedIndex === idx ? null : idx;
  this.faq[idx].display = !this.faq[idx].display;
}
 sendMessage(){
    if(!this.contactUs.valid) {
      this.sweetAlertService.showWarning('Warning', 'Please fill all the required fields');
      return;
    }   
    this.shareService.saveContactUs(this.contactUs?.value).subscribe((res)=>{
      if(res){
       this.sweetAlertService.showSuccess('Success', 'Thank you for contacting us!!');
        this.contactUs.reset();
        Object.keys(this.contactUs.controls).forEach((key) => {
          this.contactUs.get(key)?.setErrors(null);
          this.contactUs.get(key)?.markAsPristine();
          this.contactUs.get(key)?.markAsUntouched();
        });
      }
    }, err =>{
      this.sweetAlertService.showError('Error', 'Something went wrong!!');
    })
  }
 
  openWhatsapp() {
    const webLink = `https://whatsapp://send?phone=${+919059013838}`;
    const appLink = `https://wa.me/${+919059013838}`;

    window.open(appLink);
    
  }
  openGmail() {
    const recipientEmail = 'info@digiworldexpo.com'; 
    const subject = 'Hello'; 
    const body = 'I would like to connect with you.'; 
    const mailtoLink = `mailto:${recipientEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(mailtoLink, '_self');
  }
  
}
